/** Извлечь понятный текст ошибки API: {detail: "..."} или массив FastAPI 422.
 *
 * ApiError.message — это сырое тело ответа (JSON); показывать его в UI
 * нельзя — пользователь увидит английскую pydantic-простыню.
 */
export function errorDetail(err: unknown): string {
  if (!(err instanceof Error)) return String(err);
  try {
    const parsed = JSON.parse(err.message) as { detail?: unknown };
    if (typeof parsed.detail === "string") return parsed.detail;
    if (Array.isArray(parsed.detail)) {
      return parsed.detail
        .map((d) => (d && typeof d === "object" && "msg" in d ? String((d as { msg: unknown }).msg) : JSON.stringify(d)))
        .join("; ");
    }
  } catch {
    // не JSON — вернём как есть
  }
  return err.message || "Ошибка запроса";
}

/** Текст ошибки для нулевой/отрицательной суммы счёта (единая формулировка UI). */
export const INVOICE_AMOUNT_POSITIVE_ERROR =
  "Сумма счёта должна быть больше 0 — счетов на ноль не бывает " +
  "(оплата по предоплате или постоплате). Если сумма пока неизвестна — " +
  "приложите файл счёта без суммы.";

/** Явно заданная сумма счёта (строка из поля ввода) конечна и строго > 0. */
export function isInvoiceAmountValid(raw: string): boolean {
  if (raw.trim() === "") return false;
  const value = Number(raw);
  return Number.isFinite(value) && value > 0;
}
